import { Box, CircularProgress, Typography } from "@mui/material";
import { Dashboard } from "../../types";
import { SyntheticEvent } from "react";

interface IToolsContainerProps {
  isLoading: boolean;
  hasError: boolean;
  currentDashboard: Dashboard | null;
  handleIframeLoad: (e: SyntheticEvent<HTMLIFrameElement, Event>) => void;
  handleIframeError: (e: SyntheticEvent<HTMLIFrameElement, Event>) => void;
}

const ToolsContainer = ({ hasError, isLoading, currentDashboard, handleIframeError, handleIframeLoad }: IToolsContainerProps) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "calc(100% - 48px)", // Height minus the tab selector height
          display: "flex",
          justifyContent: "center",
          padding: 2
        }}
      >
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              zIndex: 2
            }}
          >
            <CircularProgress />
            <Typography color='white'>Loading dashboard...</Typography>
          </Box>
        )}

        {hasError && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              padding: 3
            }}
          >
            <Typography variant='h6' color='error' gutterBottom>
              Failed to load dashboard
            </Typography>
            <Typography variant='body2' color='white'>
              Please check your internet connection and try again.
            </Typography>
          </Box>
        )}
      </Box>

      {currentDashboard && (
        <Box sx={{ position: "relative", height: `calc(100vh - 130px)` }}>
          <iframe
            title={`${currentDashboard.name} Dashboard`}
            src={currentDashboard.url}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              display: hasError ? "none" : "block",
              backgroundColor: "white"
            }}
            onLoad={handleIframeLoad}
            onError={handleIframeError}
            allowFullScreen
            sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
          />
        </Box>
      )}
    </>
  );
};

export default ToolsContainer;
